<form novalidate
  [formGroup]="_form"
  (keydown.enter)="$event.preventDefault()"
  class="form_style">
  <div class="row">
    <div class="col-12">
      <div class="transaction-section-header">
        <div class="transaction-section-header-title">
          @if (!showTextBox) {
            <div (dblclick)="showTextbox()" class="">{{title}}</div>
          }
          <div>
            @if (showTextBox) {
              <input type="text"
                #titleTextBox
                [value]="title"
                id="titleTextBox"
                (blur)="closeTextbox($event.target)"
                (keyup.enter)="closeTextbox($event.target)" />
            }
          </div>
        </div>
        <div class="transaction-section-header-actions header-actions">
          @if (_hasFieldControlLicense) {
            <button [class.ViewModeHiddenElement]="_pageState != 2"
              class="hidden-xs asap-btn"
              kendoButton
              (click)="_editFormState()">
              <span><img [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" /></span>Edit Form
            </button>
          }

          @if (_hasFieldControlLicense) {
            <button [class.ViewModeHiddenElement]="_pageState != 4"
              class="hidden-xs asap-btn"
              kendoButton
              (click)="_returnAddNew()">
              <span><img [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" /></span>Close Edit Form
            </button>
          }
          <!--=========================Process BUTTON ===============================-->
          <button class="hidden-xs asap-btn" kendoButton
            (click)="_onSave($event)">
            <span>
              <img [src]="'/assets/menu/'+ _theme +'/proccess-icon.svg'" />
            </span>Process
          </button>
          <!--=======================================================================-->

          <button class="hidden-xs asap-btn" kendoButton (click)="_onClear()">
            <span><img [src]="'/assets/menu/'+ _theme +'/clear-icon.svg'" /></span>Clear
          </button>

        </div>
      </div>
    </div>
  </div>
  <div class="row no-row-margin">
    <div class="col-12 col-lg-6 small-pad-right">
      <div [ngClass]="isGeneralInformationExpanded == true ? 'transactionWidget' : 'transactionWidget-collapse'">
        <div class="row">
          <!-- <div class="col-12">
          <p class="titleStandardStyle">General Information</p>
        </div> -->

        <div class="col-12 sectionheader">
          <span class="titleStandardStyle">General Information</span>
          <span [ngClass]="isGeneralInformationExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
            class="float-right pointer-click"
          (click)="ExpandCollapseGeneralInfoWidget(isGeneralInformationExpanded)"></span>
        </div>

        @if (isGeneralInformationExpanded) {
          @if (getAuthByLabel('LBL_AdjustTransactionDateTime')?.canView) {
            <div class="col-12 margin-top-10"
              >
              <div class="form-group special_style_formgroup">
                <div class="row">
                  <div class="col-2">
                    <label class="control-label"> {{getLabel('LBL_AdjustTransactionDateTime')?.text}}</label>
                  </div>
                  <div kendoTooltip
                    class="col-10 transaction-receive-input-fields">
                    <kendo-datetimepicker formControlName="date"
                      class="k-datepicker datepickerControlrightMargin"
                      placeholder="Set Date and Time"
                      [attr.required]="getLabel('LBL_AdjustTransactionDateTime')?.isRequired ? 'required' : null"
                      [min]="minDate"
                      [ngClass]="{'bordered': $safeNavigationMigration(getLabel('LBL_AdjustTransactionDateTime')?.isRequired)}"
                      [format]="_datePickerFormat">
                    </kendo-datetimepicker>
                    <a title="Add {{getLabel('LBL_AdjustTransactionDateTime')?.text}}"
                      [class.editfieldsIconvisible]="_pageState == 4"
                      class="editFieldsIcon"
                      (click)="_openRenameForm('LBL_AdjustTransactionDateTime', false, false, true)">
                      <img class="searchIcon"
                        [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'"
                        style="background-position: right; margin-left:30px" />
                      </a>
                    </div>
                  </div>
                  <div class="transactions-stock-right-checkbox empty-small"></div>
                </div>
              </div>
            }
            @if (_currentUser && _currentUser.isEnterprise) {
              <div class="col-12"
                >
                <div class="form-group special_style_formgroup">
                  <div class="row">
                    <div class="col-2">
                      <label class="control-label">Account</label>
                    </div>
                    <div class="col-10 transaction-input-fields">
                      <accounts-dropdown #kendo_combo_accounts
                        [formControl]="_selectedAccount"
                        class="bordered current-step newFormControlWidth"
                        [class.active]="_selectedAccount.value == null"
                        [required]="true">
                      </accounts-dropdown>
                    </div>
                  </div>
                  <div class="transactions-stock-right-checkbox empty-small"></div>
                </div>
              </div>
            }
            <sites-dropdown #kendo_combo_sites
              layout="transaction"
              [showAllSites]="true"
              [labelText]="'Site'"
              [inputContainerClass]="'transaction-input-fields'"
              formControlName="site"
              [placeholder]="'Choose a Site'"
              [textField]="'name'"
              [valueField]="'id'"
              class="bordered current-step newFormControlWidth"
              [required]="true">
            </sites-dropdown>
            @if (getAuthByLabel('LBL_AdjustTransactionNotes')?.canView) {
              <div class="col-12"
                >
                <div class="form-group special_style_formgroup">
                  <div class="row">
                    <div class="col-2">
                      <label class="control-label">{{getLabel('LBL_AdjustTransactionNotes')?.text}}</label>
                    </div>
                    <div kendoTooltip
                      class="col-10 transaction-receive-input-fields">
                      <input type="text"
                        class="k-textbox writebox newFormControlWidth"
                        placeholder="Notes.."
                        [attr.disabled]="getAuthByLabel('LBL_AdjustTransactionNotes')?.canEdit ? null : 'disabled'"
                        [attr.required]="getLabel('LBL_AdjustTransactionNotes')?.isRequired ? 'required' : null"
                        formControlName="note" />
                        <a title="Add {{getLabel('LBL_AdjustTransactionNotes')?.text}}"
                          [class.editfieldsIconvisible]="_pageState == 4"
                          class="editFieldsIcon"
                          (click)="_openRenameForm('LBL_AdjustTransactionNotes')">
                          <img class="searchIcon"
                            [src]="'/assets/menu/'+ _theme +'/edit-icon.svg'" />
                          </a>
                        </div>
                      </div>
                    </div>
                  </div>
                }
              }
            </div>
          </div>
        </div>
        <div class="col-12 col-lg-6 small-pad-left">
          <div [ngClass]="isScanInventoryExpanded == true ? 'transactionWidget' : 'transactionWidget-collapse'">
            <div class="row">
              <!-- <div class="col-12">
              <p class="titleStandardStyle">Scan Inventory ID#</p>
            </div> -->

            <div class="col-12 sectionheader">
              <span class="titleStandardStyle">Scan Inventory ID#</span>
              <span [ngClass]="isScanInventoryExpanded == true ? 'k-icon k-i-sort-asc-sm' :  'k-icon k-i-sort-desc-sm'"
                class="float-right pointer-click"
              (click)="ExpandCollapseScanInventoryWidget(isScanInventoryExpanded)"></span>
            </div>

            @if (isScanInventoryExpanded) {
              <div class="col-12 margin-top-10">
                <div class="form-group special_style_formgroup display-flex">
                  <div class="row flex-1">
                    <div class="col-3">
                      <label class="control-label">Inventory ID#</label>
                    </div>
                    <div class="col-9 transaction-move-input-fields">
                      <kendo-combobox #kendo_combo_inventoryId
                        [data]="_inventoriesFiltered"
                        [filterable]="true"
                        (filterChange)="_handleInventoriesFilter($event)"
                        (valueChange)="_handleInventoriesChange($event)"
                        (opened)="scrollCombobox($event)"
                        (blur)="onBlur()"
                        [placeholder]="'Inventory ID'"
                        [suggest]="true"
                        [textField]="'inventoryNumber'"
                        [valueField]="'id'"
                        [formControl]="_inventoryCode"
                        class="bordered"
                        required>
                      </kendo-combobox>
                      <span class="asap-input-icon">
                        <img class="addIcon"
                          (click)="_selectInventoriesHandler()"
                          [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'" />
                        </span>
                      </div>
                    </div>
                    <div class="transactions-move-stock-right-checkbox empty">
                    </div>
                  </div>
                  <div class="form-group special_style_formgroup display-flex">
                    <div class="row flex-1">
                      <div class="col-3">
                        <label class="control-label">From Location</label>
                      </div>
                      <div class="col-9 transaction-move-input-fields">
                        <kendo-combobox #kendo_combo_from_location
                          [data]="itemFormLocationsFiltered"
                          [filterable]="true"
                          (filterChange)="_handleFromLocationsFilter($event, itemFormLocationsFiltered)"
                          [placeholder]="'From Location'"
                          [textField]="'code'"
                          [valueField]="'id'"
                          [formControl]="_fromLocation"
                          (valueChange)="_formLocationValueChange()"
                          class="bordered"
                          required>
                          <ng-template kendoComboBoxItemTemplate let-dataItem>
                            <div class="transactions-move-stock-dropdown-item">
                              <div class="truncate">{{ dataItem.code }}</div>
                              <div class="transactions-move-stock-dropdown-item-description truncate">
                                @if (dataItem.availability >= 0) {
                                  <span>| {{ dataItem.availability }}</span>
                                }
                              </div>
                            </div>
                          </ng-template>
                        </kendo-combobox>
                      </div>
                    </div>
                    <div class="transactions-move-stock-right-checkbox empty">
                    </div>
                  </div>
                  <div class="form-group special_style_formgroup display-flex">
                    <div class="row flex-1">
                      <div class="col-3">
                        <label class="control-label">Current Quantity</label>
                      </div>
                      <div class="col-9 transaction-move-input-fields">
                        <kendo-numerictextbox [disabled]="true"
                          class="k-textbox writebox required"
                          format="{{ quantityFormat }}"
                          [value]="$safeNavigationMigration(_fromLocation?.value?.availability)">
                        </kendo-numerictextbox>
                      </div>
                    </div>
                    <div class="transactions-move-stock-right-checkbox empty">
                    </div>
                  </div>
                  <div class="form-group special_style_formgroup display-flex">
                    <div class="row flex-1">
                      <div class="col-3">
                        <label class="control-label">New Quantity</label>
                      </div>
                      <div class="col-9 transaction-move-input-fields">
                        <kendo-numerictextbox #new_quantity_input
                          [autoCorrect]="true"
                          class="k-textbox writebox required"
                          [min]="0"
                          [formControl]="_quantity"
                          format="{{ quantityFormat }}"
                          (keydown.enter)="_quantityValueChange()"
                        (keydown.tab)="_quantityValueChange()"></kendo-numerictextbox>
                      </div>
                    </div>
                    <div class="transactions-move-stock-right-checkbox empty">
                    </div>
                  </div>
                  <div class="form-group special_style_formgroup display-flex">
                    <div class="row flex-1">
                      <div class="col-3">
                        <label class="control-label">Expiration Date</label>
                      </div>
                      <div class="col-9 transaction-move-input-fields">
                        <kendo-datetimepicker #expiration_date
                          class="k-datepicker"
                          [formControl]="_expirationDate"
                          [min]="_minDate"
                          placeholder="Choose Date"
                          (valueChange)="_dateChanged($event)"
                          [formatPlaceholder]="_dateLabelInput"
                        [format]="_datePickerFormat"></kendo-datetimepicker>
                      </div>
                    </div>
                    <div class="transactions-move-stock-right-checkbox empty">
                    </div>
                  </div>
                  <div class="section-separator"></div>
                </div>
                <div class="col-12">
                  <div class="form-group special_style_formgroup display-flex">
                    <div class="row flex-1">
                      <div class="col-3">
                        <label class="control-label" style="min-width: auto !important; white-space: nowrap">
                          Attached Document
                        </label>
                      </div>
                      <div #kendo_uploader_wrapper class="col-9 transaction-move-input-fields" style="display:flex;">
                        <kendo-upload [class.active]="true" [class.disabled]="false" #kendo_uploader [batch]="false"
                          [autoUpload]="false" [multiple]="true" class="NextToLabelUpload requiredDropZone"
                          (select)="_fileSelectedChanges($event)" (remove)="_fileRemoveEventHandler($event)">
                          <kendo-upload-messages [select]="_uploaderSelectMessage" [dropFilesHere]="''">
                          </kendo-upload-messages>
                        </kendo-upload>
                        <a class="cursor-pointer" (click)="_onUploadClick()">
                          <img class="searchIcon" [src]="'/assets/menu/'+ _theme +'/add-new-icon_grid.svg'" />
                        </a>
                        <a (click)="_showDocumentsGrid=true" class="asap-input-icon"><img _ngcontent-sqy-c791=""
                        class="addIcon" [src]="'/assets/menu/'+ _theme +'/multi-select-icon.svg'"></a>
                      </div>
                    </div>
                    <div class="transactions-move-stock-right-checkbox">
                      @if (_settingsPrintReceipt && _settingsPrintReceipt.enabled) {
                        <input type="checkbox" class="k-checkbox" kendoCheckBox [formControl]="_printReceipt"
                          />
                      }
                      @if (_settingsPrintReceipt && _settingsPrintReceipt.enabled) {
                        <div class="transactions-move-stock-right-checkbox-text"
                          >
                          Print Receipt
                        </div>
                      }
                    </div>
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
        <div class="col-12">
          <div class="transactionWidget with-grid numericboxtab">
            <div class="flex-space-between transaction-grid-header-wrapper">
              <p class="titleStandardStyle">Selected Items</p>
              <div class="transaction-grid-top-actions">
                <div class="transaction-grid-top-actions-radio">
                  <input type="radio"
                    id="new-to-old-items"
                    name="transaction-duration"
                    value="new"
                    [formControl]="_sortingSelected"
                    kendoRadioButton />
                    <label class="k-radio-label" [for]="'new-to-old-items'">Newest To Oldest</label>
                  </div>
                  <div class="transaction-grid-top-actions-radio">
                    <input type="radio"
                      id="old-to-new-items"
                      name="transaction-duration"
                      value="old"
                      [formControl]="_sortingSelected"
                      kendoRadioButton />
                      <label class="k-radio-label" [for]="'old-to-new-items'">Oldest To Newest</label>
                    </div>
                  </div>
                </div>

                <kendo-grid [data]="_inventoryGridData"
                  [scrollable]="'none'"
                  class="transaction-grid"
                  (remove)="_removeHandler($event)">
                  <kendo-grid-column field="inventoryCode" title="Inventory ID#">
                  </kendo-grid-column>

                  <kendo-grid-column field="stockNumber" title="Stock Item #">
                  </kendo-grid-column>

                  <kendo-grid-column field="description" title="Stock Description">
                  </kendo-grid-column>

                  <!-- <kendo-grid-column field="location" title="From Location">
                </kendo-grid-column> -->

                <kendo-grid-column field="Location" title="From Location">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <kendo-combobox #kendo_combo_locations
                      style="width: 100%"
                      [data]="dataItem.location"
                      [filterable]="true"
                      [value]="dataItem.selectedFromLocation"
                      [disabled]="dataItem.itemTypeId  == 2"
                      (filterChange)="_handleFromLocationsFilter($event, dataItem)"
                      (valueChange)="_handleFromLocationChange($event, dataItem)"
                      [suggest]="true"
                      [placeholder]="'Choose a Location'"
                      [textField]="'code'"
                      [valueField]="'id'"
                      class="bordered">
                    </kendo-combobox>
                  </ng-template>
                </kendo-grid-column>


                <kendo-grid-column field="currentQty" title="Current Quantity">
                  <!-- <ng-template kendoGridCellTemplate let-dataItem>
                  <kendo-numerictextbox
                    [disabled]="dataItem.itemTypeId  == 2"
                  ></kendo-numerictextbox>
                </ng-template> -->
              </kendo-grid-column>

              <kendo-grid-column field="newQty" title="New Quantity">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <kendo-numerictextbox [value]="dataItem.newQty" #newQuantityTextBox
                    class="k-textbox requirednumeric"
                    [min]="0"
                    [max]="dataItem.itemTypeId == 2 ? 1 : null "
                    [autoCorrect]="true"
                    (valueChange)="_onNewQtyChange(newQuantityTextBox,$event, dataItem)"
                  format="{{ quantityFormat }}"></kendo-numerictextbox>
                </ng-template>
              </kendo-grid-column>

              <kendo-grid-column field="expDate" title="Expiration Date">
                <ng-template kendoGridCellTemplate let-dataItem>
                  <div class="display-flex">
                    <kendo-datetimepicker [disabled]="dataItem.itemTypeId == 1"
                      [value]="dataItem.expDate"
                      class="k-datetimepicker"
                      (valueChange)="_onExpirationDateChange($event, dataItem)"
                    [format]="_datePickerFormat"></kendo-datetimepicker>
                  </div>
                </ng-template>
              </kendo-grid-column>
              @if (_hasFieldControlLicense && _receiveUDField1Show) {
                <kendo-grid-column
                  field="uDField1"
                  title="uDField1">
                  <ng-template kendoGridCellTemplate let-dataItem>
                    <input type="text" [value]="dataItem.udField1"
                      class="k-textbox writebox"
                      (change)="_onUDFieldChange($event, dataItem, 'uDField1')" />
                    </ng-template>
                  </kendo-grid-column>
                }

                @if (_hasFieldControlLicense && _receiveUDField2Show) {
                  <kendo-grid-column
                    field="udField2"
                    title="uDField2">
                    <ng-template kendoGridCellTemplate let-dataItem>
                      <input type="text" [value]="dataItem.udField2"
                        class="k-textbox writebox"
                        (change)="_onUDFieldChange($event, dataItem, 'uDField2')" />
                      </ng-template>
                    </kendo-grid-column>
                  }

                  @if (_hasFieldControlLicense && _receiveUDField3Show) {
                    <kendo-grid-column
                      field="uDField3"
                      title="uDField3">
                      <ng-template kendoGridCellTemplate let-dataItem>
                        <input type="text" [value]="dataItem.udField3"
                          class="k-textbox writebox"
                          (change)="_onUDFieldChange($event, dataItem, 'uDField3')" />
                        </ng-template>
                      </kendo-grid-column>
                    }

                    @if (_hasFieldControlLicense && _receiveUDFieldDate1Show) {
                      <kendo-grid-column
                        field="uDFieldDate1"
                        title="uDFieldDate1">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <div class="display-flex">
                            <kendo-datetimepicker class="k-datetimepicker" [value]="dataItem.udFieldDate1"
                              placeholder="Choose Date and Time"
                              (valueChange)="_onUDFieldChange($event, dataItem, 'uDFieldDate1')"
                              [format]="_datePickerFormat">
                            </kendo-datetimepicker>
                          </div>
                        </ng-template>
                      </kendo-grid-column>
                    }

                    @if (_hasFieldControlLicense && _receiveUDFieldDate2Show) {
                      <kendo-grid-column
                        field="uDFieldDate2"
                        title="uDFieldDate2">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <div class="display-flex">
                            <kendo-datetimepicker class="k-datetimepicker" [value]="dataItem.udFieldDate2"
                              placeholder="Choose Date and Time"
                              (valueChange)="_onUDFieldChange($event, dataItem, 'uDFieldDate2')"
                              [format]="_datePickerFormat">
                            </kendo-datetimepicker>
                          </div>
                        </ng-template>
                      </kendo-grid-column>
                    }

                    @if (_hasFieldControlLicense && _receiveUDFieldDate3Show) {
                      <kendo-grid-column
                        field="uDFieldDate3"
                        title="uDFieldDate3">
                        <ng-template kendoGridCellTemplate let-dataItem>
                          <div class="display-flex">
                            <kendo-datetimepicker class="k-datetimepicker" [value]="dataItem.udFieldDate3"
                              placeholder="Choose Date and Time"
                              (valueChange)="_onUDFieldChange($event, dataItem, 'uDFieldDate3')"
                              [format]="_datePickerFormat">
                            </kendo-datetimepicker>
                          </div>
                        </ng-template>
                      </kendo-grid-column>
                    }

                    <kendo-grid-command-column title="Action">
                      <ng-template kendoGridCellTemplate>
                        <div kendoGridRemoveCommand class="asap-grid-remove">
                          <div class="asap-grid-remove-icon">
                            <img src="/assets/menu/enterprise/remove-icon.svg" />
                          </div>
                          <div class="asap-grid-remove-text">Delete</div>
                        </div>
                      </ng-template>
                    </kendo-grid-command-column>
                  </kendo-grid>
                </div>
              </div>
            </div>

            <div class="row">
              <div class="col-12">
                @if (_invalidForm) {
                  <asap-forms-validation-summary
                    [form]="_form"
                    [page]="'breakdown'">
                  </asap-forms-validation-summary>
                }
              </div>
            </div>
          </form>

          @if (false) {
            <kendo-window>
              <div class="row zeromarginRow">
                <div class="col-12 col-lg-6 zeroPaddingColumn">
                  <div class="row zeromarginRow">
                    <div class="col-12 margin-top-10 zeroPaddingColumn">
                      <div class="form-group special_style_formgroup">
                        <div class="row zeromarginRow">
                          <div class="col-2">
                            <label class="control-label">Receive Receipt</label>
                          </div>
                          <div class="col-10 transaction-receive-input-fields">
                            <kendo-combobox #kendo_combo_Receipt_Report
                              [data]="receiveReports"
                              [suggest]="true"
                              class="bordered newFormControlWidth"
                              [textField]="'name'"
                              [valueField]="'id'"
                              placeholder="Select Receive Print Receipt">
                            </kendo-combobox>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
                <div class="col-12 margin-top-10 zeroPaddingColumn">
                  <button kendoButton
                    class="steps_buttons_class"
                    (click)="_printReceiptReport()">
                    <img class="backimage"
                      [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                      <span>Print</span>
                    </button>
                  </div>
                </div>
              </kendo-window>
            }

            @if (_editFormActive) {
              <kendo-window
                title="{{ _isCustomfieldsFormValue ? 'Add Custom Fields' : (_isAddTabFormValue ? 'Add New Tabs' : (_isRenameFormValue ? 'Edit Record' : '')) }}"
                (close)="_closeCustomFields()"
                class="customFieldsWindow">
                <asap-custom-fields [accounts]="_selectedAccountIds"
                  [labelObjectCode]="_selectedLabelObjectCode"
                  [formName]="'stock'"
                  page="adjustInventoryHistory"
                  [isCustomfieldsForm]="_isCustomfieldsFormValue"
                  [isCustomtabsForm]="_isAddTabFormValue"
                  [isRenameForm]="_isRenameFormValue"
                  [language]="_language"
                  [isRenameCustomForm]="_isRenameCustomFormValue"
                  [onlyRequired]="_onlyRequired"
                  [hasRequired]="_hasRequired"
                  [isRenameLabel]="_isRenameLabel"
                  [isMandatory]="_isMandatory"
                  [isTransaction]="_isTransaction"
                  (closePopup)="ClosePopup($event)"
                  [permissionScope]="'adjust-transactions'">
                </asap-custom-fields>
              </kendo-window>
            }

            @if (_showInventoriesGrid) {
              <kendo-window
                title="{{'Add Inventory to Adjust Inventory'}}"
                (close)="_closeInventoriesWindow()"
                class="addFromLibrary">
                <div class="greytabtop">
                  <button kendoButton
                    class="topRightButtonSelect"
                    (click)="_returnSelectedInventoriessHandler($event)">
                    Select & Return
                  </button>
                </div>
                @if (_inventoryItemsGridColumns) {
                  <asap-grid-layout
                    [page]="'inventories'"
                    [entityName]="'inventory'"
                    [sortingEnabled]="true"
                    [singleSelect]="false"
                    [enableSiteSelection]="false"
                    [orderEnable]="true"
                    [resolver]="_getInventoryItems"
                    class="ListGrid"
                    [selectable]="true"
                    [pagingEnabled]="true"
                    [selectByField]="_selectedCallback"
                    [filteringEnable]="true"
                    [addNewFormEnabled]="false"
                    [deletedEnabled]="false"
                    [headerEnable]="true"
                    [groupingEnabled]="true"
                    [canBatchActivate]="true"
                    [enableSiteSelection]="false"
                    (onRowSelectionChanges)="_onInventoryRowSelectionChanges($event)">
                    @for (column of _inventoryItemsGridColumns; track column) {
                      @if (column.selected) {
                        @if (column.isTemplate) {
                          <ng-template pageListColumn [field]="column.field" [name]="column.title" [type]="column.type"
                            let-item>
                            @if (column?.type == 'date') {
                              {{ item[column.field] | dateFormat }}
                            }
                            @if (column.formatType == costPriceFormatType
                              && column.field != 'stock.extendedCost' && column.field != 'stock.inventoryCost') {
                              {{column.field | complexFieldValue: item | costFormat}}
                            }
                            @if (column.formatType == quantityFormatType ) {
                              {{column.field | complexFieldValue: item | quantityFormat}}
                            }
                            @if (column.field == 'stock.extendedCost') {
                              {{
                              (($safeNavigationMigration(item.stockItem?.costInfo?.cost) /
                              $safeNavigationMigration(item.stockItem?.receiveUnitOfMeasure?.multiplier)) *
                              $safeNavigationMigration(item.stockItem?.inventoryUnitOfMeasure?.multiplier) *
                              item.availability) | costFormat
                              }}
                            }
                            @if (column.field == 'stock.inventoryCost') {
                              {{
                              (($safeNavigationMigration(item.stockItem?.costInfo?.cost) /
                              $safeNavigationMigration(item.stockItem?.receiveUnitOfMeasure?.multiplier)) *
                              $safeNavigationMigration(item.stockItem?.inventoryUnitOfMeasure?.multiplier)) | costFormat
                              }}
                            }
                            @if ((column?.type != 'date' || column.type==null )
                              && column.formatType != quantityFormatType && column.formatType != costPriceFormatType
                              ) {
                              {{column.field | complexFieldValue: item}}
                            }
                            @if (column.isCustomField == true) {
                              {{item[column.field]}}
                            }
                          </ng-template>
                        }
                        @if (!column.isTemplate ) {
                          <ng-template pageListColumn [field]="column.field" [name]="column.title" [type]="column.type"
                            let-item>
                            @if (column.type == 'date') {
                              {{ item[column?.field] | dateFormat }}
                            }
                            @if (column.type != 'date'  || column.type==null ) {
                              {{column.field | complexFieldValue: item}}
                            }
                            @if (column.isCustomField == true) {
                              {{item[column.field]}}
                            }
                          </ng-template>
                        }
                      }
                    }
                  </asap-grid-layout>
                }
              </kendo-window>
            }
            @if (_showReports) {
              <kendo-window [width]="750" (close)="closeReport()"
                (keydown.enter)="$event.preventDefault()">
                <div class="col-12 form-group ps-4">
                  <div style="margin-top: 10px;  margin-right: 5px;">
                    <button (click)="closeReport()" kendoButton class="steps_buttons_class">
                      <img class="backimage" [src]="'/assets/menu/'+ _theme +'/close-schedule-report-icon-green.svg'" />
                      <span>close</span>
                    </button>
                    <button (click)="_printReceiptReport()" kendoButton class="steps_buttons_class">
                      <span><img class="backimage" [src]="'/assets/menu/'+ _theme +'/print-icon.svg'" /></span>Print
                    </button>
                  </div>
                  <label class="control-label trl" style="margin-top: 15px;">Adjust Inventory</label>
                  <kendo-combobox #kendo_combo_Receipt_Report
                    [data]="_adjustInventoryReports"
                    [suggest]="true"
                    class="bordered newFormControlWidth"
                    [textField]="'name'"
                    [valueField]="'id'"
                    placeholder="Select Adjust Inventory Print Receipt">
                  </kendo-combobox>
                </div>
              </kendo-window>
            }
            @if (_showInventoriesGrid) {
              <div class="k-overlay"></div>
            }
